import { render, staticRenderFns } from "./SaidaModal.vue?vue&type=template&id=fd62f3d4&scoped=true"
import script from "./SaidaModal.vue?vue&type=script&lang=js"
export * from "./SaidaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd62f3d4",
  null
  
)

export default component.exports